"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _labelConsts = require("../../../constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("../../../logics/stringUtil"));
var _CLabel = _interopRequireDefault(require("../../materials/CLabel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * アップロード結果部品
 */
const UploadResultParts = props => {
  const {
    intl,
    uploadResult
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_UPLOAD_FILE
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, _stringUtil.default.emptyToHyphen(uploadResult.fileNm)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_DESCRIPTION
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, _stringUtil.default.emptyToHyphen(uploadResult.note)))));
};
UploadResultParts.propTypes = {
  uploadResult: _propTypes.default.object.isRequired
};
var _default = exports.default = (0, _reactIntl.injectIntl)(UploadResultParts);